<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <custom-tabs :tabItems="tabItems" v-model="tabs" grow>
          <template v-slot:staticItems>
            <v-tab-item class="pt-2">
              <Advertising‌Banner v-model="value.qr_id" />
            </v-tab-item>

            <v-tab-item>
              <advertise-space v-model="value.qr_id" />
            </v-tab-item>
          </template>
        </custom-tabs>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import PriceInput from "@/core/plugins/TitleRibbon/pages/pickers/priceInput.vue";
import AdvertiseSpace from "@/view/pages/qrland/components/qrManage/advertiseSpace.vue";
import Advertising‌Banner from "./Advertising/advertising‌Banner.vue";

export default {
  name: "manageAdvertising",
  props: {
    value: [String, Number],
  },
  components: { AdvertiseSpace, PriceInput, Advertising‌Banner },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "manageAdvertising",
    tabItems: [
      {
        text: "اجاره بنر تبلیغاتی",
        value: "banner_rental",
        icon: "panorama-variant-outline",
      },
      {
        text: "اجاره فضای تبلیغاتی",
        value: "space_rental",
        icon: "view-grid-outline",
      },
    ],
    tabs: 0,
    model: false,
    maxCount: 3,
    perDayPrice: 0,
  }),

  methods: {},
};
</script>

<style scoped></style>
